import 'material-design-lite/material';

declare module mdl {
    export interface ComponentHandler {

        /**
        * Searches existing DOM for elements of our component type and upgrades them
        * if they have not already been upgraded.
        *
        * @param optJsClass the programatic name of the element class we
        * need to create a new instance of.
        * @param optCssClass the name of the CSS class elements of this
        * type will have.
        */
        upgradeDom(optJsClass?: string, optCssClass?: string): void;


        /**
          * Upgrades a specific element rather than all in the DOM.
          *
          * @param element The element we wish to upgrade.
          * @param optJsClass Optional name of the class we want to upgrade
          * the element to.
          */
        upgradeElement(element: Element, optJsClass?: string): void;

        /**
           * Upgrades a specific list of elements rather than all in the DOM.
           *
           * @param elements
           * The elements we wish to upgrade.
           */
        upgradeElements(elements: Element | Element[] | NodeList | HTMLCollection): void;

        /**
            * Upgrades all registered components found in the current DOM. This is
            * automatically called on window load.
            */
        upgradeAllRegistered(): void;

        /**
           * Allows user to be alerted to any upgrades that are performed for a given
           * component type
           *
           * @param jsClass The class name of the MDL component we wish
           * to hook into for any upgrades performed.
           * @param callback The function to call upon an
           * upgrade. This function should expect 1 parameter - the HTMLElement which
           * got upgraded.
           */
        registerUpgradedCallback(jsClass: string, callback: (el: HTMLElement) => void): void;

        register(config: any): void;

        downgradeElements(nodes: Node | Node[] | NodeList): void;
    }
}


export const componentHandler: mdl.ComponentHandler = (window as any).componentHandler;